import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";

import { Documento } from '@app/models/documento.model';
import { DocumentoService } from '@app/services/documento.service';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-documento-lista',
  templateUrl: './documento-lista.component.html'
})
export class DocumentoListaComponent implements OnInit {

  lstDocumento: Documento[];
  paginacao: Paginacao = new Paginacao();
  filtroDescricao: string = "";
  bsModalRef: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private documentoService: DocumentoService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.documentoService.obterLista(descricao, pagina).toPromise().then(data => {
      this.lstDocumento = data.Dados,
        this.paginacao.totalDeItens = data.Total
    }, erro => {
      //this.loading = false;
      this.toastr.warning("Realize a pesquisa novamente.")
    });
  }

  deletar(documento: Documento) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir o documento: " + documento.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.documentoService.deletar(documento.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    }
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }

}
